module.exports = __webpack_public_path__ + "img/CNSS.7bdf77ae.png";